<template>
  <BModal 
    id="activity-finish-modal"
    ref="activity-finish-modal"
    centered
    hide-header
    hide-footer
    class="delete-modal"
    @hide="onModalHide"
    @click.stop
  >
    <button type="button" data-dismiss="modal" aria-label="Close" class="close" @click="hide">
        <span aria-hidden="true">
            <img src="/build/icons/close@gray.svg" width="16" height="16" class="close-icon">
      </span>
    </button>
    <div class="modal-content-wrapper">
    <div class="title">
        <span>{{ __("Como deseja finalizar a atividade?") }}</span>
    </div>
    <div class="btn-group w-100">
      <button 
        class="success-btn"
        :class="{ 'active': selectedStatus === 'success' }"
        @click="handleStatusSelect('success')"
      >
        <img 
          src="/build/icons/happy-face.svg" 
          class="btn-icon"
          :class="{ 'active': selectedStatus === 'success' }"
        />
        {{ __('Finalizado com sucesso') }}
      </button>
      <button 
        class="no-success-btn"
        :class="{ 'active': selectedStatus === 'no-success' }"
        @click="handleStatusSelect('no-success')"
      >
        <img 
          src="/build/icons/sad-face.svg" 
          class="btn-icon"
          :class="{ 'active': selectedStatus === 'no-success' }"
        />
        {{ __('Finalizado sem sucesso') }}
      </button>
    </div>
    <button
    class="salesflow-btn salesflow-btn-primary btn-save"
    type="button"
    :disabled="!selectedStatus"
    @click="handleConfirm"
    >
        {{ __('Salvar') }}
    </button>
    </div>
  </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  props: ['activityId'],

  mounted() {
    Bus.$off('openFinishActivityModal');
    Bus.$off('closeFinishActivityModal');
    
    Bus.$on('openFinishActivityModal', (activity) => this.handleOpen(activity));
    Bus.$on('closeFinishActivityModal', () => this.hide());
  },

  beforeDestroy() {
    Bus.$off('openFinishActivityModal');
    Bus.$off('closeFinishActivityModal');
  },

  data() {
    return {
      activity: null,
      observation: '',
      error: false,
      closingBySave: false,
      selectedStatus: null,
    }
  },

  methods: {
    hide() {
      this.$refs['activity-finish-modal'].hide();
      this.$emit("close");
    },

    handleOpen(activity) {
      this.activity = activity;
      this.$refs['activity-finish-modal'].show();
    },

    handleStatusSelect(status) {
      this.selectedStatus = this.selectedStatus === status ? null : status;
    },

    handleConfirm() {
      if (!this.selectedStatus) return;

      this.closingBySave = true;
      this.$emit('confirmFinish', {
        activity: this.activity,
        completed_status: this.selectedStatus === 'success' ? 'successfully' : 'unsuccessfully',
        closeModal: () => {
          this.hide();
        }
      });
    },

    onModalHide() {
      if (!this.closingBySave) {
        this.$emit("close");
      }
      
      this.closingBySave = false;
      this.error = false;
      this.observation = '';
      this.activity = null;
      this.selectedStatus = null;
    },

    handleClickOutside() {
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-content-wrapper {
  padding-left: 32px !important;
  padding-right: 32px !important;
  z-index: 9999;
}

.title {
  color: #242424;
  text-align: center;
  font-family: Montserrat;
  font-size: 18px;
  font-weight: 600;
  line-height: 150%;
  margin-bottom: 32px;
}

.btn-group {
  gap: 8px;
  display: grid;
  margin-bottom: 28.5px;

  button {
    display: flex;
    width: 100%;
    height: 40px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    background: #EDF2F6;
    border: none;
    color: #71767D;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;

    &.active {
      &.success-btn {
        background: rgba(209, 255, 202, 0.60);
        border: 1.5px solid #299D46;
        color: #0F9030;
      }

      &.no-success-btn {
        background: #FBD9D7;
        border: 1.5px solid #FF3B30;
        color: #FF3B30;
      }
    }
  }

  .success-btn {
    .btn-icon {
      width: 18px;
      height: 18px;
      filter: brightness(0) saturate(100%) invert(46%) sepia(9%) saturate(498%) hue-rotate(182deg) brightness(94%) contrast(89%);

      &.active {
        filter: brightness(0) saturate(100%) invert(45%) sepia(82%) saturate(463%) hue-rotate(101deg) brightness(95%) contrast(88%);
      }
    }

    &:hover {
      background: #B9EDB5;
      color: #0F9030;

      .btn-icon {
        filter: brightness(0) saturate(100%) invert(45%) sepia(82%) saturate(463%) hue-rotate(101deg) brightness(95%) contrast(88%);
      }
    }
  }

  .no-success-btn {
    .btn-icon {
      width: 18px;
      height: 18px;
      filter: brightness(0) saturate(100%) invert(46%) sepia(9%) saturate(498%) hue-rotate(182deg) brightness(94%) contrast(89%);

      &.active {
        filter: brightness(0) saturate(100%) invert(40%) sepia(65%) saturate(5047%) hue-rotate(343deg) brightness(100%) contrast(119%);
      }
    }

    &:hover {
      background: #FBD9D7;
      color: #FF3B30;

      .btn-icon {
        filter: brightness(0) saturate(100%) invert(40%) sepia(65%) saturate(5047%) hue-rotate(343deg) brightness(100%) contrast(119%);
      }
    }
  }
}

.close {
    margin-left: auto;
}

.btn-save {
    width: 100%;
    height: 44px;
    padding: 8px 24px;
    border-radius: 12px;
}
</style> 